import {Pipe, PipeTransform} from '@angular/core';
import {PublicHolidayDto} from '../../../Models/Rrhh/Public-holidays/public-holiday.interface';

@Pipe({
  name: 'publicHolidays',
  standalone: false
})
export class PublicHolidaysPipe implements PipeTransform {

  transform(items: PublicHolidayDto[], filter: { pendent: boolean }): PublicHolidayDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    return items.filter(item => filter.pendent ? item.state === 0 : item.state === 1);

  }

}
